howspace.components.scheduleSelect = (() => {
    'use strict';

    return {
        init: elem => {
            elem.findIncludingSelf('.howspace-schedule-select:not(.howspace-schedule-select-initialized)').each(function () {
                const scheduleSelect = $(this);
                scheduleSelect.addClass('howspace-schedule-select-initialized');

                const frequencySelect = scheduleSelect.find('.frequency-select');
                const weekdayLabel = scheduleSelect.find('.weekday-label');
                const weekdaySelect = weekdayLabel.find('select');
                const monthLabel = scheduleSelect.find('.month-label');
                const monthSelect = monthLabel.find('select');
                const timeLabel = scheduleSelect.find('.time-label');
                const timeSelect = timeLabel.find('select');
                const scheduleInput = scheduleSelect.find('input.schedule-input');

                // adjust time to browser timezone
                let time = timeSelect.data('utc-time');
                if (time) {
                    time = howspace.components.time.getBrowserTime(time);
                    timeSelect.val(time);
                }

                const updateSchedule = () => {
                    let scheduleTime = timeSelect.val() || '';
                    if (scheduleTime !== '') {
                        scheduleTime = howspace.components.time.getUtcTime(scheduleTime);
                    }

                    const scheduleWeekday = weekdaySelect.val();
                    const scheduleMonth = monthSelect.val();
                    let schedule;

                    switch (frequencySelect.val()) {
                        case 'daily':
                            schedule = 'today ' + scheduleTime;
                            break;

                        case 'weekly':
                            schedule = scheduleWeekday + ' this week ' + scheduleTime;
                            break;

                        case 'monthly':
                            schedule = 'first ' + scheduleWeekday + ' of this month';
                            break;

                        case 'annually':
                            schedule = 'first ' + scheduleWeekday + ' of ' + scheduleMonth + ' this year';
                            break;

                        default:
                            schedule = '';
                            break;
                    }

                    scheduleInput.val(schedule);
                };

                frequencySelect.on('change', function () {
                    switch ($(this).val()) {
                        case 'daily':
                            weekdayLabel.addClass('d-none');
                            timeLabel.removeClass('d-none');
                            monthLabel.addClass('d-none');
                            break;

                        case 'weekly':
                            weekdayLabel.removeClass('d-none');
                            timeLabel.removeClass('d-none');
                            monthLabel.addClass('d-none');
                            break;

                        case 'monthly':
                            weekdayLabel.removeClass('d-none');
                            timeLabel.addClass('d-none');
                            monthLabel.addClass('d-none');
                            break;

                        case 'annually':
                            weekdayLabel.removeClass('d-none');
                            timeLabel.addClass('d-none');
                            monthLabel.removeClass('d-none');
                            break;

                        default:
                            weekdayLabel.addClass('d-none');
                            timeLabel.addClass('d-none');
                            monthLabel.addClass('d-none');
                            break;
                    }

                    updateSchedule();
                });

                weekdaySelect.on('change', updateSchedule);
                timeSelect.on('change', updateSchedule);
                monthSelect.on('change', updateSchedule);
            });
        },
        destroy: elem => {
            elem.findIncludingSelf('.howspace-schedule-select.howspace-schedule-select-initialized').each(function () {
                const scheduleSelect = $(this);
                scheduleSelect.removeClass('howspace-schedule-select-initialized');
            });
        },
        reset: elem => {
            const frequencySelect = elem.find('.frequency-select');
            frequencySelect.val('').trigger('change');
        }
    }
})();
